<template>
  <div>
    <div v-if='errors'>
      <p v-for='(val, key, index) in errors' :key='index'>
        {{val.message}}
      </p>
    </div>
    <textarea :placeholder='placeholder' spellcheck="true" v-model='composedText' @keydown="handleKeyDown($event)" />
    <button v-show='!sendingMessage' class='btn btn-primary float-right' @click='send()' :disabled='sendDisabled'>
      <i class="fa fa-paper-plane-o mr-1"></i>SEND</button>
    <div class='file-upload-btn' v-if='!hideAttachment'>
      <i class='fa fa-paperclip'></i>
      <input style='file-upload-input' type='file' multiple class='file-upload-input' v-on:change='uploadFile($event)' />
    </div>
  </div>
</template>

<script>
  import {
    MessengerAPIClient
  } from '@/lib/data_access/messenger'
  import {
    MessageType
  } from '@/lib/utilities/enums'

  import moment from 'moment'

  export default {
    name: 'composer',
    data() {
      return {
        composedText: '',
        sendingMessage: false,
        errors: []
      }
    },
    props: [
      'placeholder',
      'customSubmit',
      'hideAttachment',
      'sendDisabled',
      'user'
    ],
    methods: {
      handleKeyDown(event) {
        let vm = this;
        vm.errors = [];
        if (event.key == "Enter" && !event.shiftKey) {
          if (!vm.sendingMessage) {
            vm.send()
          }
        }
      },
      send() {
        let vm = this;
        console.log('What is this', vm)
        let possibleErrors = validMessage(vm.composedText)
        if (!vm.customSubmit) {
          if (possibleErrors.length == 0) {
            vm.sendingMessage = true;
            let messagePack = createMessagePack({
              Group: this.$parent.group,
              Message: vm.composedText,
              User: vm.user
            })
            MessengerAPIClient.sendMessage(messagePack).then(function () {
              vm.sendingMessage = false
              vm.composedText = ''
            })
          } else {
            vm.errors = possibleErrors
          }
        }
        else
        {
          if(possibleErrors){
          vm.$emit('composeSubmit', vm.composedText)            
          }
          else{
            vm.errors = ''
          }
        }

      },
      uploadFile(event) {
        let vm = this;
        var files = event.target.files;
        MessengerAPIClient.uploadFiles(files, vm.$parent.group.GroupId)
      }
    }
  }

  function createMessagePack(data) {
    try {
      var messageText = data.Message;
      var user = data.User;
      var group = data.Group;

      if (!group || !group.GroupId)
        return;

      group.ComposedMessage = '';

      //Generate chat package for api
      var userIds = [];
      if (group.Members && group.Members.length > 0)
        userIds = group.Members.map(function (member) {
          return member.UserId;
        });

      var chatPackage = {
        GroupId: group.GroupId,
        UserIds: userIds,
        Message: messageText
      };

      var timetoken = moment().valueOf() * 10000;

      var sender = user;
      console.log(user)
      //Generate a temporary message for display
      var message = {
        GroupId: group.GroupId,
        MessageId: 'Message-' + timetoken,
        MessageText: messageText, //.replace(/\r*\n/g, "<br/>"),
        Messages: [{
          Language: user.Language,
          Text: messageText //.replace(/\r*\n/g, "<br/>")
        }],
        SenderId: user.Id,
        SenderName: user.Name,
        SenderAvatarUrl: user.AvatarUrl,
        Sender: sender,
        CreatedUtc: moment().toISOString(),
        // AttachmentFile: {
        //     Url: null,
        //     Name: null
        // },
        MessageType: MessageType.User,
        Timetoken: timetoken,
        IsSystem: false,
        IsFirstUnread: false
      };

      // group.Messages = group.Messages || [];
      // group.Messages.push(message);

      var messagePackage = {
        ChatPackage: chatPackage,
        Message: message
      };

      return messagePackage;
    } catch (error) {
      console.log(error)
    }
  }

  function validMessage(message) {
    let errors = [];
    if (message.length > 4000) {
      errors.push({
        name: 'length',
        message: 'Message exceeds character limit'
      })
    }
    return errors
  }

</script>

<style lang="scss" scoped>
  textarea {
    border: 2px solid #e7e7e7;
    border-radius: 10px;
    width: 100%;
    padding: 5px;
    line-height: 20px;
    display: block;
    resize: none;
    background: #fff;
    overflow-x: hidden;
    transition: all .3s ease;
    margin-bottom: 5px;

  }

  .btn {
    border-radius: 13px;
    padding: .375rem .75rem;
    font-weight: 300;
  }

  .file-upload-btn {
    position: relative;
    display: inline-block;
    overflow: hidden;
    cursor: pointer; // background-color: #e5e5e5;
    // padding: 0px 10px 0px 5px;
    // border-radius: 10px;
    // font-size: 12px;
    // cursor: pointer;
    .file-upload-input {
      position: absolute;
      top: 0;
      left: 0; // border: 1px solid green;
      cursor: pointer;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Messenger/Composer.vue